import * as React from 'react'
import trendUp from './trend-up.svg'
import trendSame from './trend-same.svg'
import trendDown from './trend-down.svg'
import s from './displacementArrow.m.scss'
import clsx from 'clsx'

interface Props {
  /** Previous rank, can also be a string
   * (like "neu") – if it can't be parsed into a number, no arrow will be rendered */
  previous: number | string

  /** The current rank */
  current: number
}

/**
 * Show an arrow for the trend
 */
export function DisplacementArrow({ previous, current }: Props) {
  let previousRank = previous
  if (typeof previous === 'string') {
    previousRank = parseInt(previous, 10)
  }
  let imageSrc = trendSame
  let trendClassName = 'trend-same'
  if (!isNaN(previousRank)) {
    const currentRank = current

    if (previousRank < currentRank) {
      imageSrc = trendDown
      trendClassName = 'trend-down'
    }

    if (previousRank > currentRank) {
      imageSrc = trendUp
      trendClassName = 'trend-up'
    }

    return (
      <img
        src={imageSrc}
        alt=''
        className={clsx(
          s.displacementArrow,
          'displacement-arrow',
          trendClassName
        )}
      />
    )
  }

  return <span style={{ display: 'inline-block', width: '0' }} />
}
